
export const USERS = 'users';



// WEBPACK FOOTER //
// ./src/API/constants/index.js